module.exports = __webpack_public_path__ + "static/media/itilt.bc20463d.png";